const formsList = [
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Listing Forms",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "MLC",
    title: "Multiple Listing Contract",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "ELC",
    title: "Exclusive Listing Contract",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "colist-joint",
    title: "Co-Listing Form - Joint Representation",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "colist-separate",
    title: "Co-Listing Form - Separate Representation",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "lease-res",
    title: "Authority to Lease - Residential",
  },
  {
    type: "form",
    category: ["listing"],
    formNumber: "listing-amendment",
    title: "Listing Amendment (various types)",
  },
  {
    type: "form",
    category: ["listing"],
    formNumber: "lockbox-auth",
    title: "Lockbox Acknowledgement, Consent, Release, and Indemnity",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Buyer Forms",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "buyer-acknowledgement",
    title: "Buyer Agency Acknowledgement",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "BAEC",
    title: "Buyer Agency Exclusive Contract",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "buyer-ack-info",
    title: "Buyer's Acknowledgement of Information - Recommended Conditions",
  },

  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "CPS-res",
    title: "Contract of Purchase and Sale (CPS) - Residential",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "CPS-manu",
    title: "CPS - Manufactured Home on a Rental Site",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "CPS-nothird",
    title: "CPS - Leasehold in First Nations - 3rd Party Approval Not Required",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "CPS-yesthird",
    title: "CPS - Leasehold in First Nations - 3rd Party Approval Required",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "assign-new-dev",
    title: "Assignment of Contract of Purchase and Sale - New Development",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "CPS-addendum",
    title: "CPS - Addendum/Amendment",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "CPS-manu-addendum",
    title: "CPS - Manufactured Home - Addendum",
  },
  {
    type: "form",
    category: ["listing"],
    formNumber: "PNC",
    title: "Privacy Notice & Consent Form",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "notice-seller-assignment-terms",
    title: "Notice to Seller of Assignment of Terms",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "fee-agreement-seller-pays",
    title: "Fee Agreement - Seller Pays",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Disclosure Forms",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-interest-buying",
    title: "Disclosure of Interest in Trade - Buying/Selling",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-interest-lease",
    title: "Disclosure of Interest in Trade - Leasing/Renting",
  },
  {
    type: "form",
    category: ["listing"],
    formNumber: "PDS-res",
    title: "Property Disclosure Statement - Residential",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "PNDS",
    title: "Property No-Disclosure Statement (PNDS)",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-referral-payment",
    title: "Disclosure of Referral Payment",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-referral-received",
    title: "Disclosure of Referral Payment Received",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-seller-remuneration",
    title: "Disclosure to Seller of Expected Remuneration",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-of-remuneration",
    title: "Disclosure of Remuneration",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-unrep",
    title: "Disclosure of Risks to Unrepresented Parties",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "disc-conflict-interest",
    title: "Disclosure Regarding Conflict of Interest Between Clients",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Rental Placement Forms",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "tenant-agency-contract",
    title: "Tenant Agency Exclusive Contract",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "fee-agreement-landlord-pays",
    title: "Fee Agreement - Landlord Pays",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Additional Forms",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "fee-service-agreement",
    title: "Fee for Service Agreement",
  },
  {
    type: "form",
    category: ["all"],
    formNumber: "general-release",
    title: "General Release & Authorization to Pay Deposit Funds",
  },
];

export default formsList;
